import { rootLogger } from '@hyperlane-xyz/utils';
export const widgetLogger = rootLogger.child({ module: 'widgets' });
//# sourceMappingURL=logger.js.map